"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDecoratedComponent_1 = require("./utils/getDecoratedComponent");
var discount_lodash_1 = require("./utils/discount_lodash");
var invariant = require('invariant');
var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
var TargetImpl = /** @class */ (function () {
    function TargetImpl(spec, monitor, ref) {
        this.spec = spec;
        this.monitor = monitor;
        this.ref = ref;
        this.props = null;
    }
    TargetImpl.prototype.receiveProps = function (props) {
        this.props = props;
    };
    TargetImpl.prototype.receiveMonitor = function (monitor) {
        this.monitor = monitor;
    };
    TargetImpl.prototype.canDrop = function () {
        if (!this.spec.canDrop) {
            return true;
        }
        return this.spec.canDrop(this.props, this.monitor);
    };
    TargetImpl.prototype.hover = function () {
        if (!this.spec.hover) {
            return;
        }
        this.spec.hover(this.props, this.monitor, getDecoratedComponent_1.getDecoratedComponent(this.ref));
    };
    TargetImpl.prototype.drop = function () {
        if (!this.spec.drop) {
            return undefined;
        }
        var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);
        if (process.env.NODE_ENV !== 'production') {
            invariant(typeof dropResult === 'undefined' || discount_lodash_1.isPlainObject(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' +
                'Instead received %s. ' +
                'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', dropResult);
        }
        return dropResult;
    };
    return TargetImpl;
}());
function createTargetFactory(spec) {
    Object.keys(spec).forEach(function (key) {
        invariant(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' +
            'some of the following keys: %s. ' +
            'Instead received a specification with an unexpected "%s" key. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', ALLOWED_SPEC_METHODS.join(', '), key);
        invariant(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' +
            'Instead received a specification with %s: %s. ' +
            'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', key, key, spec[key]);
    });
    return function createTarget(monitor, ref) {
        return new TargetImpl(spec, monitor, ref);
    };
}
exports.default = createTargetFactory;



//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/lib/cjs/createTargetFactory.js
// module id = 1292
// module chunks = 0